import type { WebauthnCredential as GQLItem } from '../../generated/api.graphql';
import { take } from '../../util';

export type WebauthnCredential = {
  id: string;
  nickname: string | null;
  createdAt: string;
  lastUsedAt: string | null;
  transports: string[];
};

export const fromGQL = (item: GQLItem): WebauthnCredential =>
  take<WebauthnCredential>(item, 'id', 'nickname', 'createdAt', 'lastUsedAt', 'transports');
